/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectionChecker } from '../models/ConnectionChecker';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ConnectionCheckerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ConnectionChecker resource.
     * Retrieves a ConnectionChecker resource.
     * @returns ConnectionChecker ConnectionChecker resource
     * @throws ApiError
     */
    public apiInternalcheckLegacyDbConnectionGet(): CancelablePromise<ConnectionChecker> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/_internal/check-legacy-db-connection',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Retrieves a ConnectionChecker resource.
     * Retrieves a ConnectionChecker resource.
     * @returns ConnectionChecker ConnectionChecker resource
     * @throws ApiError
     */
    public apiInternalcheckStatsDbConnectionGet(): CancelablePromise<ConnectionChecker> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/_internal/check-stats-db-connection',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
